import { parseDomain } from '@wix/domains-serverless-interface';
import { BULK_AVAILABILITY_MAX_DOMAINS, CAROUSEL_CHUNK_SIZE, TLD_OFFERS_PAGE_SIZE, TOP_TLDS_COUNT } from './tldOfferWidget.constants';
export const getCandidateTlds = (suggestedTlds, catalogTlds, searchedTld) => [...new Set([...suggestedTlds, ...[...catalogTlds].sort((a, b) => a.localeCompare(b))])].filter(tld => tld !== searchedTld);
export const getBatch = (candidates, batchIndex) => candidates.slice(batchIndex * BULK_AVAILABILITY_MAX_DOMAINS, (batchIndex + 1) * BULK_AVAILABILITY_MAX_DOMAINS);
export const getNextBatchIndex = (loadedBatches, candidatesCount) => loadedBatches * BULK_AVAILABILITY_MAX_DOMAINS < candidatesCount ? loadedBatches : undefined;
export const toPurchasableTlds = results => results.filter(_ref => {
  let itemMetadata = _ref.itemMetadata,
    item = _ref.item;
  return (itemMetadata == null ? void 0 : itemMetadata.success) && (item == null ? void 0 : item.available) && !(item != null && item.premium);
}).map(_ref2 => {
  let item = _ref2.item;
  return parseDomain((item == null ? void 0 : item.domain) ?? '').tld ?? '';
});
export const shouldCheckAnotherBatch = _ref3 => {
  let foundCount = _ref3.foundCount,
    checkedBatches = _ref3.checkedBatches,
    minTlds = _ref3.minTlds,
    maxBatches = _ref3.maxBatches,
    hasMoreCandidates = _ref3.hasMoreCandidates;
  return hasMoreCandidates && foundCount < minTlds && checkedBatches < maxBatches;
};
export const hasLoadedPage = (page, offersCount) => page * TLD_OFFERS_PAGE_SIZE < offersCount;
export const shouldLoadNextBatch = _ref4 => {
  let page = _ref4.page,
    offersCount = _ref4.offersCount,
    hasMore = _ref4.hasMore,
    isFetching = _ref4.isFetching;
  return hasMore && !isFetching && !hasLoadedPage(page + 1, offersCount);
};
export const shouldLoadNextBatchForSlide = _ref5 => {
  let chunkIndex = _ref5.chunkIndex,
    offersCount = _ref5.offersCount,
    hasMore = _ref5.hasMore,
    isFetching = _ref5.isFetching;
  return hasMore && !isFetching && (chunkIndex + 2) * CAROUSEL_CHUNK_SIZE >= offersCount;
};
export const getExpandPageNumber = _ref6 => {
  let isExpanded = _ref6.isExpanded,
    isFolded = _ref6.isFolded,
    page = _ref6.page;
  if (!isExpanded) {
    return 1;
  }
  return isFolded ? page + 1 : page + 2;
};
export const shouldFoldStrip = (offers, topTlds) => offers.filter(tld => topTlds.includes(tld)).length < TOP_TLDS_COUNT;
//# sourceMappingURL=tldOfferWidget.utils.js.map